// Begin Specialty List ; with license plate codes and additional fees to issue plate//
// F.S. 320.08056 and 320.08058
// --- Environmental / Wildlife //(count 23)
const ANR = 'Animal Friend,ANR,ANP,$30';
const ABR = 'America The Beautiful,ABR,ABP,$30';
const QCR = 'Aquaculture,QCR,QCP,$30';
const B4R = 'Bonefish & Tarpon Trust,B4R,B4P,$30';
const CWR = 'Conserve Wildlife,CWR,CWP,$30';
const C0R = 'Coastal Conservation Assn,C0R,C0P,$30';
const DFR = 'Discover Florida Oceans,DFR,DFP,$30';
const ERR = 'Everglades River of Grass,ERR,ERP,$25';
const EOR = 'Explore Off Road,EOR,EOP,$30';
const P1R = 'Explore Our State Parks,P1R,P1P,$30';
const FVR = 'Fish Florida,FVR,FVP,$27';
const F1R = 'Florida Bay Forever,F1R,F1P,$30';
const FBR = 'Florida Biodiversity - Save Wild Florida,FBR,FBP,$30';
const INR = 'Indian River Lagoon,INR,INP,$20';
const LBR = 'Largemouth Bass,LBR,LBP,$30';
const BIR = 'Protect Biscayne Bay,BIR,BIP,$30';
const LXR = 'Protect The Gopher Tortoise,LXR,LXP,$30';
const VLR = 'Protect the Panther,VLR,VLP,$30';
const PFR = 'Protect Florida Springs,PFR,PFP,$30';
const WHR = 'Protect Florida Whales,WHR,WHP,$30';
const PIR = 'Protect Marine Wildlife,PIR,PIP,$30';
const PNR = 'Protect Our Oceans,PNR,PNP,$30'; // formerly Catch Me; Release Me
const POR = 'Protect Our Reefs,POR,POP,$30';
const PWR = 'Protect Wild Dolphins,PWR,PWP,$25';
const SZR = 'Save Our Seas,SZR,SZP,$30';
const F9R = 'Save the Bees,F9R,F9P,$30';
const MTR = 'Save the Manatee,MTR,MTP,$30';
const STR = 'Sea Turtle,STR,STP,$28';
const FFR = 'State Wildflower,FFR,FFP,$20';
const SWR = 'Support Scenic Walton,SWR,SWP,$30';
const TAR = 'Tampa Bay Estuary,TAR,TAP,$20';
const TCR = 'Trees are Cool,TCR,TCP,$30';
const WLR = 'Wildlife Foundation of Florida,WLR,WLP,$30'; // formerly Sportsmen's Trust,
// --- Special Interest / Community //(count 25)
const AER = 'Agricultural Education,AER,AEP,$30';
const AGR = 'Agriculture,AGR,AGP,$25';
const BRR = 'Big Brothers Big Sisters,BRR,BRP,$30';
const CLR = 'Challenger Columbia,CLR,CLP,$30';
const DXR = 'Ducks Unlimited,DXR,DXP,$30';
const GAR = 'Dont Tread on Me,GAR,GAP,$30';
const ESR = 'Endless Summer,ESR,ESP,$30';
const ARR = 'Florida Arts, ARR,ARP,$25';
// eslint-disable-next-line quotes
const HFR = `Florida Horse Park (Discover Florida's Horses),HFR,HFP,$30`;
const SKR = 'Florida Sheriffs Association,SKR,SKP,$30';
const F7R = 'Florida Stands With Israel,F7R,F7P,$30';
/* const FYR = 'Florida Sheriffs Youth Ranches,FYR,FYP,$30'; */
const TNR = 'Florida Tennis,TNR,TNP,$30';
const ORR = 'Fraternal Order of Police,ORR,ORP,$30';
const FQR = 'Free Masonry,FQR,FQP,$30';
const GOR = 'Golf Capital,GOR,GOP,$30';
const HAR = 'HomeOwnership,HAR,HAP,$30';
const HRR = 'Horse Country,HRR,HRP,$30';
const IMR = 'Imagine,IMR,IMP,$30'; // (Florida Food Bank)
const IGR = 'In God We Trust,IGR,IGP,$30';
const K9R = 'K9s United,K9R,K9P,$30';
const LHR = 'Lighthouse Association - Visit our Lights,LHR,LHP,$30';
const LDR = 'Live the Dream,LDR,LDP,$30';
const B6R = 'Margaritaville,B6R,B6P,$30';
const AHR = 'Police Athletic League,AHR,AHP,$25';
const SAR = 'Share the Road,SAR,SAP, $20';
/* const SPR = 'Special Olympics,SPR,SPP,$20'; */
const EER = 'Support Education,EER,EEP,$25';
const LLR = 'Swim For Life,LLR,LLP,$30';
 /* const SYR = 'Support Soccer,SYR,SYP,$30'; */
const SOR = 'US Olympic,SOR,SOP,$20';
const WDR = 'Walt Disney World,WDR,WDP,$30';
// --- Special Interest / Health //(count 7)
const CSR = 'Choose Life,CSR,CSP,$25';
const CRR = 'End Breast Cancer,CRR,CRP,$30';
const HOR = 'Hospice,HOR,HOP,$30';
const MJR = 'Moffitt Cancer Center,MJR,MJP,$25';
/* const VIR = 'State of Vision,VIR,VIP,$30'; */
const SDR = 'Stop Heart Disease,SDR,SDP,$30';
const ASR = 'Support Autism Programs,ASR,ASP,$30';
// --- Special Interest / Family / Kids  // (count 9)
const B2R = 'Best Buddies,B2R,B2P,$30';
/* const SCR = 'Boy Scouts,SCR,SCP,$25'; */
const FJR = 'Family First,FJR,FJP,$30';
const FUR = 'Family Values,FUR,FUP,$30';
const CHR = 'Invest in Children,CHR,CHP,$25';
/* const KKR = 'Keep Kids Drug Free,KKR,KKP,$30'; */
/* const KDR = 'Kids deserve Justice,KDR,KDP,$30'; */
// eslint-disable-next-line quotes
const LKR = `Lauren's Kids,LKR,LKP,$30`;
/* const PMR = 'Parents make a Difference,PMR,PMP,$30'; */
const CAR = 'Stop Child Abuse, CAR,CAP,$30';
// --- Military (American Heroes) // (count 13)
const ALR = 'American Legion,ALR,ALP,$30';
const BAR = 'Blue Angels,BAR,BAP,$30';
const OFR = 'Fallen Law Enforcement Officers,OFR,OFP,$30';
const VTR = 'Florida Salutes Veterans,VTR,VTP,$20';
const SFR = 'Salutes Firefighters,SFR,SFP,$25';
const PBR = 'Support Law Enforcement,PBR,PBP,$25';
const TSR = 'Support our Troops,TSR,TSP,$30';
const WER = 'United We Stand,WER,WEP,$30';
const AFR = 'US Air Force,AFR,AFP,$20';
const AYR = 'US Army,AYR,AYP,$20';
const GUR = 'US Coast Guard,GUR,GUP,$20';
const UAR = 'US Marine Corps,UAR,UAP,$20';
const NAR = 'US Navy,NAR,NAP,$20';
const UPR = 'US Paratrooper,UPR,UPP,$25';
// --- Professional Sports //(count 10)
const CTR = 'Florida Panthers,CTR,CTP,$30';
const DER = 'Inter Miami CF,DER,DEP,$30';
const JJR = 'Jacksonville Jaguars,JJR,JJP,$30';
const MDR = 'Miami Dolphins,MDR,MDP,$30';
const MHR = 'Miami Heat,MHR,MHP,$30';
const MAR = 'Miami Marlins,MAR,MAP,$30';
const NZR = 'Nascar,NZR,NZP,$30';
const OLR = 'Orlando City,OLR,OLP,$30';
const OMR = 'Orlando Magic,OMR,OMP,$30';
const BBR = 'Tampa Bay Bucs,BBR,BBP,$30';
const DRR = 'Tampa Bay Rays,DRR,DRP,$30';
const TBR = 'Tampa Bay Lightning,TBR,TBP,$30';
// --- Collegiate //(count 36)
const ADR = 'Advent Health University,ADR,ADP,$30';
const A1R = 'Auburn University,A1R,A1P,$30';
const AVR = 'Ave Maria University,AVR,AVP,$30';
const BUR = 'Barry University,BUR,BUP,$30';
const B0R = 'Beacon College,B0R,B0P,$30';
const BCR = 'Bethune-Cookman,BCR,BCP,$30';
const EKR = 'Eckerd College,EKR,EKP,$30';
const EBR = 'Edward Waters University,EBR,EBP,$30';
const EMR = 'Embry-Riddle,EMR,EMP,$30';
const EGR = 'Everglades University,EGR,EGP,$30';
const F0R = 'Flagler College,F0R,F0P,$30';
const FMR = 'Florida A&M,FMR,FMP,$30';
const FAR = 'Florida Atlantic,FAR,FAP,$30';
const F8R = 'Florida College,F8R,F8P,$30';
const FGR = 'Florida Gulf Coast,FGR,FGP,$30';
const FHR = 'Florida Hospital University,FHR,FHP,$30';
const F2R = 'Florida Institute of Technology,F2R,F2P,$30';
const FIR = 'Florida International University,FIR,FIP,$30';
const F3R = 'Florida Memorial,F3R,F3P,$30,';
const F6R = 'Florida Southern,F6R,F6P,$30';
const FSR = 'Florida State University,FSR,FSP,$30';
const HUR = 'Hodges University,HUR,HUP,$30';
const JAR = 'Jacksonville University,JAR,JAP,$30';
const KER = 'Keiser University,KER,KEP,$30';
const LYR = 'Lynn University,LYR,LYP,$30';
const NWR = 'New College,NWR,NWP,$30';
const NOR = 'Nova Southeastern University,NOR,NOP,$30';
const PDR = 'Palm Beach Atlantic University,PDR,PDP,$30';
const RIR = 'Ringling School,RIR,RIP,$30';
const R0R = 'Rollins College,R0R,R0P,$30';
const S0R = 'Saint Leo University,S0R,S0P,$30';
const S2R = 'Saint Thomas University,S2R,S2P,$30';
const S4R = 'Southeastern University,S4R,S4P,$30';
const S3R = 'Stetson University,S3R,S3P,$30';
const U1R = 'University of Alabama,U1R,U1P,$30';
const UCR = 'University of Central Florida,UCR,UCP,$30';
const UFR = 'University of Florida,UFR,UFP,$30';
const UGR = 'University of Georgia,UGR,UGP,$30';
const UMR = 'University of Miami,UMR,UMP,$30';
const UNR = 'University of North Florida,UNR,UNP,$30';
const USR = 'University of South Florida,USR,USP,$30';
const U0R = 'University of Tampa,U0R,U0P,$30';
const UWR = 'University of West Florida,UWR,UWP,$30';
const WUR = 'Warner University,WUR,WUP,$30';
const WIR = 'Webber International University,WIR,WIP,$30';

// --- Motorcyle  // (count 2)
const RBR = 'Motorcycle Blue Angels,RBR,RBP,$30';
const MYR = 'Motorcycle Specialty,MYR,MYP,$22';
const MUR = 'Motorcycle Underage,MUR MUP,$0';

// No longer issued
// const SBR Superbowl no longer issued 12/31/92
// const GSR Girl Scouts no longer issued 1/15/02
// const QUR Quincentennial no longer issued 12/31/93
// const MOR Miami Hooters no longer issued 12/31/97
// const OPR Orlando Predators no longer issued 1/15/02
// const BSR Tampa Bay Storm no longer issued 1/15/02
// const CFR Corrections Foundation no longer issued 12/01/09
// const CCR = "Clearwater Christian College,CCR,CCP,$30"; no longer issued 05/06/2017
// const RXR = "American Red Cross,RXR,RXP,$30"; no longer issued 05/06/2017
// const DOR = "Donate Organs,DOR,DOP,$30"; no longer issued 05/06/2017

// Presale Only
// const SJR = "PRESALE ONLY - St.John's River,SJR,SJP,$30"; // PRESALE ONLY --
// const HVR = "PRESALE ONLY - Hispanic Achievers,HVR,HVP,$30"; // PRESALE ONLY --

// total 126 plates
// need 128
// END Specialty List

// note fees shown adjusted for additional fees,but calculation uses old fee schedule codes

const specialityPlates = [{
  cName: 'Environmental / Wildlife',
  oSubMenu: [{
    cName: `${ANR}`,
    cReturn: `${ANR}|27.00`,
  },
  {
    cName: `${ABR}`,
    cReturn: `${ABR}|27.00`,
  },
  {
    cName: `${QCR}`,
    cReturn: `${QCR}|27.00`,
  },
  {
    cName: `${B4R}`,
    cReturn: `${B4R}|27.00`,
  },
  {
    cName: `${CWR}`,
    cReturn: `${CWR}|27.00`,
  },
  {
    cName: `${C0R}`,
    cReturn: `${C0R}|27.00`,
  },
  {
    cName: `${DFR}`,
    cReturn: `${DFR}|27.00`,
  },
  {
    cName: `${ERR}`,
    cReturn: `${ERR}|22.00`,
  },
  {
    cName: `${EOR}`,
    cReturn: `${EOR}|27.00`,
  },
  {
    cName: `${P1R}`,
    cReturn: `${P1R}|27.00`,
  },
  {
    cName: `${FVR}`,
    cReturn: `${FVR}|24.00`,
  },
  {
    cName: `${F1R}`,
    cReturn: `${F1R}|27.00`,
  },
  {
    cName: `${FBR}`,
    cReturn: `${FBR}|27.00`,
  },
  {
    cName: `${INR}`,
    cReturn: `${INR}|17.00`,
  },
  {
    cName: `${LBR}`,
    cReturn: `${LBR}|27.00`,
  },
  {
    cName: `${BIR}`,
    cReturn: `${BIR}|27.00`,
  },
  {
    cName: `${LXR}`,
    cReturn: `${LXR}|27.00`,
  },
  {
    cName: `${VLR}`,
    cReturn: `${VLR}|27.00`,
  },
  {
    cName: `${PFR}`,
    cReturn: `${PFR}|27.00`,
  },
  {
    cName: `${WHR}`,
    cReturn: `${WHR}|27.00`,
  },
  {
    cName: `${PIR}`,
    cReturn: `${PIR}|27.00`,
  },
  {
    cName: `${PNR}`,
    cReturn: `${PNR}|27.00`,
  },
  {
    cName: `${POR}`,
    cReturn: `${POR}|27.00`,
  },
  {
    cName: `${PWR}`,
    cReturn: `${PWR}|22.00`,
  },
  {
    cName: `${SZR}`,
    cReturn: `${SZR}|27.00`,
  },
  {
    cName: `${F9R}`,
    cReturn: `${F9R}|27.00`,
  },
  {
    cName: `${MTR}`,
    cReturn: `${MTR}|27.00`,
  },
  // {cName:""+SJR+"",bEnabled: false,cReturn:""+SJR+"|"},
  {
    cName: `${STR}`,
    cReturn: `${STR}|25.00`,
  },
  {
    cName: `${FFR}`,
    cReturn: `${FFR}|17.00`,
  },
  {
    cName: `${SWR}`,
    cReturn: `${SWR}|27.00`,
  },
  {
    cName: `${TAR}`,
    cReturn: `${TAR}|17.00`,
  },
  {
    cName: `${TCR}`,
    cReturn: `${TCR}|27.00`,
  },
  {
    cName: `${WLR}`,
    cReturn: `${WLR}|27.00`,
  },
  {
    cName: '-',
  },
  ],
    //(count 23)
}, {
  cName: 'Community Interest',
  oSubMenu: [{
    cName: `${AER}`,
    cReturn: `${AER}|27.00`,
  },
  {
    cName: `${AGR}`,
    cReturn: `${AGR}|22.00`,
  },
  {
    cName: `${BRR}`,
    cReturn: `${BRR}|27.00`,
  },
  {
    cName: `${CLR}`,
    cReturn: `${CLR}|27.00`,
  },
  {
    cName: `${DXR}`,
    cReturn: `${DXR}|27.00`,
  },
  {
    cName: `${GAR}`,
    cReturn: `${GAR}|27.00`,
  },
  {
    cName: `${ESR}`,
    cReturn: `${ESR}|27.00`,
  },
  {
    cName: `${ARR}`,
    cReturn: `${ARR}|22.00`,
  },
  {
    cName: `${HFR}`,
    cReturn: `${HFR}|27.00`,
  },
  {
    cName: `${SKR}`,
    cReturn: `${SKR}|27.00`,
  },
  {
    cName: `${F7R}`,
    cReturn: `${F7R}|27.00`,
  },
/*  {
    cName: `${FYR}`,
    cReturn: `${FYR}|27.00`,
  }, */
  {
    cName: `${TNR}`,
    cReturn: `${TNR}|27.00`,
  },
  {
    cName: `${ORR}`,
    cReturn: `${ORR}|27.00`,
  },
  {
    cName: `${FQR}`,
    cReturn: `${FQR}|27.00`,
  },
  {
    cName: `${GOR}`,
    cReturn: `${GOR}|27.00`,
  },
  // {cName:""+HVR+"",bEnabled: false,cReturn:""+HVR+"|"},
  {
    cName: `${HAR}`,
    cReturn: `${HAR}|27.00`,
  },
  {
    cName: `${HRR}`,
    cReturn: `${HRR}|27.00`,
  },
  {
    cName: `${IMR}`,
    cReturn: `${IMR}|27.00`,
  },
  {
    cName: `${IGR}`,
    cReturn: `${IGR}|27.00`,
  },
  {
    cName: `${K9R}`,
    cReturn: `${K9R}|27.00`,
  },
  {
    cName: `${LHR}`,
    cReturn: `${LHR}|27.00`,
  },
  {
    cName: `${LDR}`,
    cReturn: `${LDR}|27.00`,
  },
  {
    cName: `${B6R}`,
    cReturn: `${B6R}|27.00`,
  },
  {
    cName: `${AHR}`,
    cReturn: `${AHR}|22.00`,
  },
  {
    cName: `${SAR}`,
    cReturn: `${SAR}|17.00`,
  },
/*  {
    cName: `${SPR}`,
    cReturn: `${SPR}|17.00`,
  }, */
  {
    cName: `${EER}`,
    cReturn: `${EER}|22.00`,
  },
  {
    cName: `${LLR}`,
    cReturn: `${LLR}|27.00`,
  },
/*  {
    cName: `${SYR}`,
    cReturn: `${SYR}|27.00`,
  }, */
  {
    cName: `${SOR}`,
    cReturn: `${SOR}|17.00`,
  },
  {
    cName: `${WDR}`,
    cReturn: `${WDR}|27.00`,
  },
  {
    cName: '-',
  },
  ],
    //(count 25)
}, {
  cName: 'Health Interest',
  oSubMenu: [ /* {
            cName: `${RXR}`,
            cReturn: `${RXR}|27.00`,
        }, */
    {
      cName: `${CSR}`,
      cReturn: `${CSR}|22.00`,
    },
/*  {
        cName: `${DOR}`,
        cReturn: `${DOR}|27.00`,
    }, */
    {
      cName: `${CRR}`,
      cReturn: `${CRR}|27.00`,
    },
    {
      cName: `${HOR}`,
      cReturn: `${HOR}|27.00`,
    },
    {
      cName: `${MJR}`,
      cReturn: `${MJR}|27.00`,
    },
/*    {
      cName: `${VIR}`,
      cReturn: `${VIR}|27.00`,
    }, */
    {
      cName: `${SDR}`,
      cReturn: `${SDR}|27.00`,
    },
    {
      cName: `${ASR}`,
      cReturn: `${ASR}|27.00`,
    },
    {
      cName: '-',
    },
  ],
    //(count 7)
}, {
  cName: 'Family / Kids',
  oSubMenu: [{
    cName: `${B2R}`,
      cReturn: `${B2R}|27.00`,
  },
/*  {
    cName: `${SCR}`,
    cReturn: `${SCR}|22.00`,
  }, */
  {
    cName: `${FJR}`,
    cReturn: `${FJR}|27.00`,
  },
  {
    cName: `${FUR}`,
    cReturn: `${FUR}|27.00`,
  },
  {
    cName: `${CHR}`,
    cReturn: `${CHR}|22.00`,
  },
/*  {
    cName: `${KKR}`,
    cReturn: `${KKR}|27.00`,
  }, */
/*  {
    cName: `${KDR}`,
    cReturn: `${KDR}|27.00`,
  }, */
  {
    cName: `${LKR}`,
    cReturn: `${LKR}|27.00`,
  },
/*  {
    cName: `${PMR}`,
    cReturn: `${PMR}|27.00`,
  }, */
  {
    cName: `${CAR}`,
    cReturn: `${CAR}|27.00`,
  },
  {
    cName: '-',
  },
  ],
    //(count 9)
}, {
  cName: 'American Heroes',
  oSubMenu: [
    {
      cName: `${ALR}`,
      cReturn: `${ALR}|27.00`,
    },
    {
      cName: `${BAR}`,
      cReturn: `${BAR}|27.00`,
    },
    {
      cName: `${OFR}`,
      cReturn: `${OFR}|27.00`,
    },
    {
      cName: `${VTR}`,
      cReturn: `${VTR}|17.00`,
    },
    {
      cName: `${SFR}`,
      cReturn: `${SFR}|22.00`,
    },
    {
      cName: `${PBR}`,
      cReturn: `${PBR}|22.00`,
    },
    {
      cName: `${TSR}`,
      cReturn: `${TSR}|27.00`,
    },
    {
      cName: `${WER}`,
      cReturn: `${WER}|27.00`,
    },
    {
      cName: `${AFR}`,
      cReturn: `${AFR}|17.00`,
    },
    {
      cName: `${AYR}`,
      cReturn: `${AYR}|17.00`,
    },
    {
      cName: `${GUR}`,
      cReturn: `${GUR}|17.00`,
    },
    {
      cName: `${UAR}`,
      cReturn: `${UAR}|17.00`,
    },
    {
      cName: `${NAR}`,
      cReturn: `${NAR}|17.00`,
    },
    {
      cName: `${UPR}`,
      cReturn: `${UPR}|22.00|2`,
    },
    {
      cName: '-',
    },
  ],
    //(count 13)
}, {
  cName: 'Professional Sports',
  oSubMenu: [{
    cName: `${CTR}`,
    cReturn: `${CTR}|27.00`,
  },
  {
    cName: `${DER}`,
    cReturn: `${DER}|27.00`,
  },
  {
    cName: `${JJR}`,
    cReturn: `${JJR}|27.00`,
  },
  {
    cName: `${MDR}`,
    cReturn: `${MDR}|27.00`,
  },
  {
    cName: `${MHR}`,
    cReturn: `${MHR}|27.00`,
  },
  {
    cName: `${MAR}`,
    cReturn: `${MAR}|27.00`,
  },
  {
    cName: `${NZR}`,
    cReturn: `${NZR}|27.00`,
  },
  {
    cName: `${OLR}`,
    cReturn: `${OLR}|27.00`,
  },
  {
    cName: `${OMR}`,
    cReturn: `${OMR}|27.00`,
  },
  {
    cName: `${BBR}`,
    cReturn: `${BBR}|27.00`,
  },
  {
    cName: `${DRR}`,
    cReturn: `${DRR}|27.00`,
  },
  {
    cName: `${TBR}`,
    cReturn: `${TBR}|27.00`,
  },
  {
    cName: '-',
  },
  ],
    //(count 10)
}, {
  cName: 'Collegiate',
  oSubMenu: [{
    cName: `${ADR}`,
    cReturn: `${ADR}|27.00`,
  },
  {
    cName: `${A1R}`,
    cReturn: `${A1R}|27.00`,
  },
  {
    cName: `${AVR}`,
    cReturn: `${AVR}|27.00`,
  },
  {
    cName: `${BUR}`,
    cReturn: `${BUR}|27.00`,
  },
  {
    cName: `${B0R}`,
    cReturn: `${B0R}|27.00`,
  },
  {
    cName: `${BCR}`,
    cReturn: `${BCR}|27.00`,
  },
/*  {
    cName: `${CCR}`,
    cReturn: `${CCR}|27.00`,
  }, */
  {
    cName: `${EKR}`,
    cReturn: `${EKR}|27.00`,
  },
  {
    cName: `${EBR}`,
    cReturn: `${EBR}|27.00`,
  },
  {
    cName: `${EMR}`,
    cReturn: `${EMR}|27.00`,
  },
  {
    cName: `${EGR}`,
    cReturn: `${EGR}|27.00`,
  },
  {
    cName: `${F0R}`,
    cReturn: `${F0R}|27.00`,
  },
  {
    cName: `${FMR}`,
    cReturn: `${FMR}|27.00`,
  },
  {
    cName: `${FAR}`,
    cReturn: `${FAR}|27.00`,
  },
  {
    cName: `${F8R}`,
    cReturn: `${F8R}|27.00`,
  },
  {
    cName: `${FGR}`,
    cReturn: `${FGR}|27.00`,
  },
  {
    cName: `${FHR}`,
    cReturn: `${FHR}|27.00`,
  },
  {
    cName: `${F2R}`,
    cReturn: `${F2R}|27.00`,
  },
  {
    cName: `${FIR}`,
    cReturn: `${FIR}|27.00`,
  },
  {
    cName: `${F3R}`,
    cReturn: `${F3R}|27.00`,
  },
  {
    cName: `${F6R}`,
    cReturn: `${F6R}|27.00`,
  },
  {
    cName: `${FSR}`,
    cReturn: `${FSR}|27.00`,
  },
  {
    cName: `${HUR}`,
    cReturn: `${HUR}|27.00`,
  },
  {
    cName: `${JAR}`,
    cReturn: `${JAR}|27.00`,
  },
  {
    cName: `${KER}`,
    cReturn: `${KER}|27.00`,
  },
  {
    cName: `${LYR}`,
    cReturn: `${LYR}|27.00`,
  },
  {
    cName: `${NWR}`,
    cReturn: `${NWR}|27.00`,
  },
  {
    cName: `${NOR}`,
    cReturn: `${NOR}|27.00`,
  },
  {
    cName: `${PDR}`,
    cReturn: `${PDR}|27.00`,
  },
  {
    cName: `${RIR}`,
    cReturn: `${RIR}|27.00`,
  },
  {
    cName: `${R0R}`,
    cReturn: `${R0R}|27.00`,
  },
  {
    cName: `${S0R}`,
    cReturn: `${S0R}|27.00`,
  },
  {
    cName: `${S2R}`,
    cReturn: `${S2R}|27.00`,
  },
  {
    cName: `${S4R}`,
    cReturn: `${S4R}|27.00`,
  },
  {
    cName: `${S3R}`,
    cReturn: `${S3R}|27.00`,
  },
  {
    cName: `${U1R}`,
    cReturn: `${U1R}|27.00`,
  },
  {
    cName: `${UCR}`,
    cReturn: `${UCR}|27.00`,
  },
  {
    cName: `${UFR}`,
    cReturn: `${UFR}|27.00`,
  },
  {
    cName: `${UGR}`,
    cReturn: `${UGR}|27.00`,
  },
  {
    cName: `${UMR}`,
    cReturn: `${UMR}|27.00`,
  },
  {
    cName: `${UNR}`,
    cReturn: `${UNR}|27.00`,
  },
  {
    cName: `${USR}`,
    cReturn: `${USR}|27.00`,
  },
  {
    cName: `${U0R}`,
    cReturn: `${U0R}|27.00`,
  },
  {
    cName: `${UWR}`,
    cReturn: `${UWR}|27.00`,
  },
  {
    cName: `${WUR}`,
    cReturn: `${WUR}|27.00`,
  },
  {
    cName: `${WIR}`,
    cReturn: `${WIR}|27.00`,
  },
  {
    cName: '-',
  },
  ],
    //(count 35)
}, {
  cName: 'Motorcyle',
  oSubMenu: [{
    cName: `${RBR}`,
    cReturn: `${RBR}|27.00`,
  },
  {
    cName: `${MYR}`,
    cReturn: `${MYR}|19.00`,
  },
  {
    cName: `${MUR}`,
    cReturn: `${MUR}|0.00`,
  },
  {
    cName: '-',
  },
  ],
    //(count 2)
    //total plate count 121
}];

module.exports = specialityPlates;
